import React from "react";
import styled from "styled-components";
import { Link } from "../link";
import trianglify from "trianglify";
import { useTheme } from "../../styles";

export interface LinkProps {
  to: string;
}

const Warpper = styled(Link)<LinkProps>`
  width: 100%;
  margin: 20px 10px;
  position: relative;
  margin: 1.5rem 0.5rem;
  font-size: 0.95rem;
  font-weight: normal;
  overflow: hidden;
  -webkit-transition: all 0.3s ease-out;
  -moz-transition: all 0.3s ease-out;
  -ms-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
  padding: 0.5rem 8px;
  margin: 0 auto;
  max-width: 400px;
  &:hover,
  &:focus {
    > div {
      > div {
        transform: scale(1.1);
      }
      > span {
        transform: scale(1.1);
      }
    }
  }
  > div {
    padding: 0 0;
    width: 100%;
    overflow: hidden;
    margin-bottom: 10px;
    position: relative;
    padding-top: 56.25%;
    > span {
      width: 100%;
      height: 100%;
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 0;
      transition: all 0.5s;
      overflow: hidden;
      background: ${({ theme }) => theme.colors.cerulean};
      svg {
        min-width: 100%;
        min-height: 100%;
      }
    }
    > div {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background-size: 150% auto;
      background-position: center;
      transition: 0.5s all;
      max-height: 250px;
      background: black;
    }
  }
  p {
    display: block;
    font-size: 1.1rem;
    margin-bottom: 0.3rem;
    line-height: 1.5em;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.text};
  }
`;

const map = [
  ["#6CC2BD", "#005b34", "#9DCFC2"],
  ["#d42128", "#ffb717", "#6d1e6a"],
  ["#F67E7D", "#5A819E", "#7D7AA2"],
];

const Content: React.FC<Props> = ({ title, image, link }) => {
  if (image) {
    return (
      <Warpper to={link}>
        <div>
          <div
            style={{ backgroundImage: `url(${image})` }}
            loading="lazy"
            intrinsicsize="250 x 150"
            alt={image.split("/").pop()}
          />
        </div>
        <p>{title}</p>
      </Warpper>
    );
  } else {
    const pattern = trianglify({
      height: 180,
      width: 200,
      variance: 0.7,
      cellSize: 150,
      xColors: map[Math.floor(Math.random() * map.length)],
    });
    return (
      <Warpper to={link}>
        <div>
          <span
            dangerouslySetInnerHTML={{
              __html: pattern.toSVGTree({ includeNamespace: false }).toString(),
            }}
          />
        </div>
        <p>{title}</p>
      </Warpper>
    );
  }
};

const ContentCard = React.memo(Content);

export { ContentCard };

export interface Props {
  title?: string;
  image?: string;
  link: boolean;
}
